import { ClientBaseBillingInfo } from '@zerops/models/client';

export class ClientBaseState {
  billingInfo: {
    current: ClientBaseBillingInfo;
    future: ClientBaseBillingInfo
  };
}
